<h1 mat-dialog-title class="text-center"><div translate>FILE_LIST.DIALOG.EMPTY</div></h1>
<div mat-dialog-content>

   <div class="row text-center">

   	<div class="col-4">
   		<h3 translate>FILE_LIST.DIALOG.STEP1</h3>

   	</div>
   	<div class="col-4">
		<h3 translate>FILE_LIST.DIALOG.STEP2</h3>

   	</div>
	<div class="col-4">
		<h3 translate>FILE_LIST.DIALOG.STEP3</h3>

   	</div>
   </div> <div class="row text-center">
	<div class="col-4">
   		
   		<div>
			<fa-layers class="fa-5x">
	          <fa-icon [icon]="['fas', 'folder']" class="fa-stack-5x"></fa-icon>
	          <fa-icon [inverse]="true" [icon]="['fas','plus']"  class="fa-stack-5x" transform="shrink-8 right-3"></fa-icon>
	        </fa-layers>
	    </div>
   		
   	</div>
   	<div class="col-4">
		
			<fa-icon [icon]="['far', 'folder']" class="fa-5x"></fa-icon>
			
			<fa-layers class="fa-3x">
	          
				
	          <fa-icon [icon]="['far','file']"  class="fa-stack-4x" ></fa-icon>

	          <fa-icon [icon]="['fas', 'mouse-pointer']"  transform="shrink-5  right-5 down-9"></fa-icon>

	        </fa-layers>

		
   	</div>
	<div class="col-4">
		
		<fa-layers class="fa-5x">
	          <fa-icon [icon]="['fas', 'cloud']" class="fa-stack-5x"></fa-icon>
	          <fa-icon [inverse]="true" [icon]="['fas','bolt']"  class="fa-stack-5x" transform="shrink-8 right-2"></fa-icon>
	        </fa-layers>

	
   	</div>
   </div> <div class="row text-center">
	<div class="col-4">
   		
   		<div translate>FILE_LIST.DIALOG.CREATE_FOLDER</div>
   	</div>
   	<div class="col-4">
		

		<div translate>FILE_LIST.DIALOG.UPLOAD_FILES</div>
   	</div>
	<div class="col-4">
		

		<div translate>FILE_LIST.DIALOG.RUN_TRANSFORM</div>
   	</div>

   </div>

</div>
<div mat-dialog-actions class="text-right">
    
    <button color="primary" mat-button (click)="onClick()">{{ 'GENERIC.OK' | translate }}</button>
    
</div>